function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconCropAndRotateFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.01 11.003v2.074h-5.036V24.05c0 .562-.45 1.037-1.024 1.037H13.02v4.916H10.97v-4.916H5.96v-2.074h5.012V12.04c0-.561.45-1.037 1.024-1.037h10.932V6.012h2.047v4.991h5.036zm-16.992 12.01h9.909v-9.936h-9.909v9.936zM4.04 14.673H2.034s0-.33.005-.492c.012-.323.042-.778.116-1.318.147-1.075.47-2.521 1.19-3.952.722-1.438 1.853-2.876 3.61-3.884 1.758-1.009 4.062-1.54 7.054-1.298l-.162 1.993c-2.666-.216-4.552.268-5.897 1.04-1.347.773-2.232 1.881-2.818 3.047-.59 1.173-.868 2.389-.995 3.324a11.358 11.358 0 00-.104 1.423l.005.117z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 1l4.991 3.686L12 8.373",
    fill: props.color
  }));
}

export default SvgIconCropAndRotateFilled;